// extracted by css-extract-rspack-plugin
export default {"cls1":"JournalSubscriptionPage-cls1_PDl","cls2":"JournalSubscriptionPage-cls2_rwm JournalSubscriptionPage-cls1_PDl"};